import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Multiselect from 'vue-multiselect'
import interceptorsSetup from '@/configs/axios'
import setupSentry from '@/configs/sentry'
import setupObservability from '@/configs/observability'
import { reloadOnceForStaleChunk } from '@/utils/chunk-reload'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

// Recover from stale lazy-load chunks after a deploy. The HTML-served-as-JS
// case ("Unexpected token '<'") surfaces via window.onerror, not router.onError.
window.addEventListener('error', (event) => {
  reloadOnceForStaleChunk(event?.error || { message: event?.message }, event?.filename)
})
window.addEventListener('unhandledrejection', (event) => {
  reloadOnceForStaleChunk(event?.reason)
})

setupObservability(router)
interceptorsSetup()
const app = createApp(App)
setupSentry(app)
app.use(store)
app.use(router)
app.use('multiselect', Multiselect)
app.component('Datepicker', Datepicker)
app.mount('#app')
